"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SidebarContentLoader = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _SidebarLoadingIndicator = require("./SidebarLoadingIndicator");
var _SidebarContentLoader = require("./SidebarContentLoader.styled");
var SidebarContentLoader = exports.SidebarContentLoader = function SidebarContentLoader(_ref) {
  var isLoading = _ref.isLoading,
    children = _ref.children,
    contentHeader = _ref.contentHeader,
    headerComponent = _ref.headerComponent;
  return /*#__PURE__*/_react["default"].createElement(_SidebarContentLoader.StyledWrapper, null, /*#__PURE__*/_react["default"].createElement(_SidebarContentLoader.ContentHeader, null, contentHeader, headerComponent), isLoading ? /*#__PURE__*/_react["default"].createElement(_SidebarLoadingIndicator.SidebarLoadingIndicator, {
    message: "loading indicator todo"
  }) : children);
};
SidebarContentLoader.propTypes = {
  isLoading: _propTypes.bool.isRequired,
  children: _propTypes.node.isRequired,
  contentHeader: _propTypes.string,
  headerComponent: _propTypes.node
};